import { render, staticRenderFns } from "./SlotCardSeparator.vue?vue&type=template&id=00b68228&scoped=true&"
import script from "./SlotCardSeparator.vue?vue&type=script&lang=js&"
export * from "./SlotCardSeparator.vue?vue&type=script&lang=js&"
import style0 from "./SlotCardSeparator.vue?vue&type=style&index=0&id=00b68228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b68228",
  null
  
)

export default component.exports